import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'A conta não foi aprovada',
  description: 'Corrija o que a equipe apontou e reenvie. A conta volta para análise ao salvar.',
  noteLabel: 'Nota da equipe Bodyprint',
  editAndResubmit: 'Editar e reenviar',
  contact: 'Falar com a Bodyprint',
} satisfies TranslationTree;
